module.exports = __webpack_public_path__ + "img/picacode.1cbd903e.svg";